module.exports = __webpack_public_path__ + "img/israel_no.a30f35ef.png";